import React, {FC, memo} from "react";
import {useResize} from "../../hooks";
import PreviewImage from "./components/PreviewImage/PreviewImage";
import PreviewElement from "./components/PreviewElement/PreviewElement";
import {ResultContainer, Root, ScreenshotContainer, ScrollableContainer, RandomContainer} from "./ResultPreview-styles";
import {ResultPreviewProps} from "./ResultPreview-types";
import {useResultPreviewSections} from "./ResultPreview-hooks";
import {useRecoilValue} from "recoil";
import {stateAccessoriesBlocks, stateComplectationBlocks} from "../../data/atoms";
import ButtonRandomize from "../ButtonRandomize/ButtonRandomize";


const ResultPreview: FC<ResultPreviewProps> = memo((props) => {
    const complectations = useRecoilValue(stateComplectationBlocks);
    const accessories = useRecoilValue(stateAccessoriesBlocks);

    const {parameters, screenshotRef, headReference, isLoading, isActive, onRandomClick} = props;

    const {baseHeight} = useResize();

    const {sections, references} = useResultPreviewSections(complectations, accessories);

    if (isLoading || !parameters || !complectations || !complectations.length) {
        return null;
    }

    return (
        <Root $isActive={isActive} $slideOffset={headReference.current?.offsetHeight || 0}>
            <ScrollableContainer $isActive={isActive}>

                <ScreenshotContainer ref={screenshotRef}>
                    <ResultContainer $width={parameters.width} $height={parameters.height} $baseHeight={baseHeight}>
                        {
                            sections.map(section => (
                                <PreviewElement key={section.uid} baseHeight={baseHeight} parameters={parameters}
                                                image={section.image}>

                                    <PreviewImage
                                        key={section.image.png + section.image.svg}
                                        uid={section.uid}
                                        references={references}
                                        svg={section.image.svg}
                                        mask={section.image.png}/>

                                </PreviewElement>
                            ))
                        }
                    </ResultContainer>
                </ScreenshotContainer>

                <RandomContainer>
                    <ButtonRandomize title="Сгенерировать случайную сумку" onClick={onRandomClick}/>
                </RandomContainer>

            </ScrollableContainer>
        </Root>
    )
});

export default ResultPreview;
